import { FormikField, Input, ListRow, Separator, Text, VisuallyHidden } from '@betterment/samba-react';
import { iconDisplayForSecurity } from '@betterment/shared-components/src/utils/accountSecurityHelpers';
import { FieldArray, useFormikContext } from 'formik';
import { Fragment } from 'react/jsx-runtime';

import { SecurityGroupAllocation } from './types';

export const SecurityGroupAllocationFields = () => {
  const {
    values: { securityGroupAllocations },
  } = useFormikContext<{ securityGroupAllocations: SecurityGroupAllocation[] }>();

  return (
    <FieldArray name="securityGroupAllocations">
      {() =>
        securityGroupAllocations.map((securityGroupAllocation, index) => {
          const {
            securityGroup: { primarySecurity },
          } = securityGroupAllocation;

          return (
            <Fragment key={primarySecurity.id}>
              <Separator />
              <ListRow css={{ paddingX: 0 }}>
                <ListRow.LeadingAsset>
                  {iconDisplayForSecurity({ symbol: primarySecurity.symbol, logo: primarySecurity.logo })}
                </ListRow.LeadingAsset>
                <ListRow.LeadingContent>
                  <Text color="text.selected" variant="text50">
                    {primarySecurity.symbol}
                  </Text>
                  <Text variant="text50">{primarySecurity.name}</Text>
                </ListRow.LeadingContent>
                <ListRow.TrailingContent css={{ marginLeft: 'space.150' }}>
                  <FormikField name={`securityGroupAllocations[${index}].targetWeight`}>
                    <FormikField.Label>
                      <VisuallyHidden>Target weight for {primarySecurity.name}</VisuallyHidden>
                    </FormikField.Label>
                    <FormikField.Control>
                      <Input
                        css={{ width: 'size.900' }}
                        alignment="right"
                        trailingSymbol="%"
                        type="number"
                        spacing="compact"
                      />
                    </FormikField.Control>
                  </FormikField>
                </ListRow.TrailingContent>
              </ListRow>
            </Fragment>
          );
        })
      }
    </FieldArray>
  );
};
